module.exports = __webpack_public_path__ + "media/step-3.e5b6cf8a.mp4";